import { useRef, useEffect } from 'react'
import { useLanguage } from '@context/LanguageContext'
import InfoCard from '../cards/InfoCard'
import styles from './CreditsModal.module.css'

export default function CreditsModal ({ isOpen, onClose }) {
  const { t } = useLanguage()
  const dialogRef = useRef(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return

    if (isOpen && !dialog.open) {
      dialog.showModal()
    } else if (!isOpen && dialog.open) {
      dialog.close()
    }
  }, [isOpen])

  // Handle backdrop click (click on dialog itself, not content)
  const handleBackdropClick = (e) => {
    if (e.target === dialogRef.current) {
      onClose()
    }
  }

  return (
    <dialog
      ref={dialogRef}
      className={styles.creditsModal}
      onClose={onClose}
      onClick={handleBackdropClick}
    >
      <header className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{t.about.credits.title}</h2>
        <button
          type='button'
          className={styles.modalClose}
          onClick={onClose}
          aria-label={t.about.access.credits.close}
        >
          ✕
        </button>
      </header>

      <div className={styles.modalContent}>
        <div className={styles.creditsGrid}>
          <InfoCard
            title={t.about.credits.sections.development.title}
            links={[{
              href: 'https://instagram.com/tr4p0.dev',
              text: 'Instagram',
              ariaLabel: t.about.access.credits.instagramLink
            }]}
          >
            <p>{t.about.credits.sections.development.text}</p>
          </InfoCard>

          <InfoCard title={t.about.credits.sections.inspiration.title}>
            <p>{t.about.credits.sections.inspiration.text}</p>
          </InfoCard>

          <InfoCard title={t.about.credits.sections.audio.title}>
            <p>
              {t.about.credits.sections.audio.text}<br />
              {t.about.credits.sections.audio.authors}
            </p>
          </InfoCard>

          <InfoCard
            title={t.about.credits.sections.effects.title}
            links={[
              {
                href: 'https://alvaromontoro.com/blog/68017/creating-a-fireworks-effect-with-css',
                text: t.about.credits.sections.effects.links.tutorial,
                ariaLabel: t.about.access.credits.tutorialLink
              },
              {
                href: 'https://www.alvaromontoro.com',
                text: t.about.credits.sections.effects.links.blog,
                ariaLabel: t.about.access.credits.blogLink
              }
            ]}
          >
            <p>
              {t.about.credits.sections.effects.confetti}<br />
              {t.about.credits.sections.effects.fireworks}
            </p>
          </InfoCard>

          <InfoCard title={t.about.credits.sections.icons.title}>
            <p>{t.about.credits.sections.icons.text}</p>
          </InfoCard>

          <InfoCard title={t.about.credits.sections.images.title}>
            <p>{t.about.credits.sections.images.text}</p>
          </InfoCard>
        </div>

        <footer className={styles.disclaimer}>
          <small className={styles.disclaimerText}>
            {t.about.credits.disclaimer}
          </small>
        </footer>
      </div>
    </dialog>
  )
}
